import { ITabItem } from 'components/common/tab-view';

export type SaleMethodTab = 'FIXED PRICE' | 'AUCTION';
export const saleMethodTabs: ITabItem<SaleMethodTab>[] = [
  { key: 'FIXED PRICE' },
  { key: 'AUCTION' },
];
